import React from "react";
import { SectionHeading } from "~/components/DetailsPage/components";
import { Box } from "@mui/material";
import { CveRiskFactors, EmptySection } from "~/components/vulnerabilities";
import { SoftwareDetailsFindingsNode } from "~/pages/inventory/components/AssetSoftwareDetails/types";

type SoftwareRiskFactorsProps = {
  software: SoftwareDetailsFindingsNode;
};

export const SoftwareRiskFactors = ({ software }: SoftwareRiskFactorsProps) => {
  return (
    <Box id="risk-factors" className="section">
      <SectionHeading heading="Vulnerability insights" />
      {software.cvss && software.epss ? (
        <Box className="section-content">
          <CveRiskFactors
            id="cve-risk-factors"
            cvssScore={software.cvss}
            epssScore={software.epss}
          />
        </Box>
      ) : (
        <EmptySection
          id="software-risk-assessment-empty"
          text="There are no vulnerabilities to assess"
        />
      )}
    </Box>
  );
};
